module.exports = __webpack_public_path__ + "static/media/jeff-bezos.2b53cd27.jpg";